import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GLOBAL } from './global.service';
import { UserService } from './user.service';
import { Member } from '../models/member.model';
import { Deputies } from '../models/deputy.model';
import { Search } from '../models/search.model';

@Injectable({
  providedIn: 'root'
})
export class DeputyService {
  private url: string;
  private identity: any;
  private token: string;
  private contType = {
    h: 'Content-Type',
    b: 'application/json',
  }
  private auth = {
    h: 'Authorization',
    b: '',
  }
  constructor(private _http: HttpClient, private _userService: UserService) {
    this.url = GLOBAL.API.url;
    this.auth.b = _userService.getToken();
  }

  listDiputys: () => Observable<any> = () => {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this._userService.getToken());
    return this._http.get(`${this.url}admin/diputados`, { headers: headers });
  }

  getDeputy: (deputyId: string) => Observable<any> = deputyId => {
    let headers = new HttpHeaders().set(this.contType.h, this.contType.b);
    return this._http.get(`${this.url}admin/diputados/${deputyId}`, { headers: headers });
  }

  addDeputy: (deputy: Deputies) => Observable<any> = deputy => {
    let params = JSON.stringify(deputy);
    let headers = new HttpHeaders().set(this.contType.h, this.contType.b).set(this.auth.h, this.auth.b);
    return this._http.post(`${this.url}admin/diputados`, params, { headers: headers });
  }

  deleteDeputy(deputyId: string): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this._userService.getToken());
    return this._http.delete(`${this.url}admin/diputados/${deputyId}`, { headers: headers });
  }

  searchDeputy: (find: Search) => Observable<any> = find => {
    let params = JSON.stringify(find);
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this._userService.getToken());
    return this._http.put(`${this.url}admin/diputados`, params, { headers: headers });
  }

  updateDeputy: (deputy: Deputies) => Observable<any> = deputy => {
    let params = JSON.stringify(deputy);
    let headers = new HttpHeaders().set(this.contType.h, this.contType.b).set(this.auth.h, this.auth.b);
    return this._http.put(`${this.url}admin/diputados/${deputy.id}`, params, { headers: headers });
  }
}
